import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

const COLORS = ['#C8B6FF', '#FFC8DD', '#A2D2FF', '#FFE8A3', '#B9F3D0', '#F5B841', '#FF8FAB'];
const LINES = [
  'Allt för idag är avbockat! Farmor Elsa är så stolt över dig, gumman 💛',
  'Titta på dig! Varenda sak är gjord. Sätt dig nu med en kopp kaffe, det har du förtjänat ☕',
  'Klart, klart, klart! Så där ja, nu får resten av dagen bara vara mjuk 🌸',
  'Hela dagens lista avklarad. Jag visste att du kunde, lilla vän ✨',
  'Bravo! En dag i taget, och idag tog du hela dagen 💐',
];

export const fireDayDone = () => window.dispatchEvent(new Event('focus-critter:day-done'));
export const eventsChanged = () => window.dispatchEvent(new Event('focus-critter:events-changed'));

export function StreakChip({ testid = 'done-streak-chip' }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    let t;
    const load = () => axios.get(`${API}/calendar/done-streak`, cfg).then((r) => setS(r.data)).catch(() => {});
    const later = () => { clearTimeout(t); t = setTimeout(load, 900); };
    load();
    window.addEventListener('focus-critter:events-changed', later);
    return () => { clearTimeout(t); window.removeEventListener('focus-critter:events-changed', later); };
  }, []);
  if (!s) return null;
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5 text-[11px] font-black rounded-full px-2.5 py-1 bg-[#FFF1E0] text-[#8A4B10] border border-[#F5B841]" data-testid={testid}>
      🔥 {s.streak} {s.streak === 1 ? 'dag' : 'dagar'} i rad
      {s.badges.filter((b) => b.earned).map((b) => <span key={b.days} title={b.name}>{b.emoji}</span>)}
      {s.next_badge && <span className="font-semibold opacity-75">· {s.next_badge.emoji} om {s.next_badge.days_left} {s.next_badge.days_left === 1 ? 'dag' : 'dagar'}</span>}
    </span>
  );
}

export default function DayDoneCelebration() {
  const [burst, setBurst] = useState(null);
  useEffect(() => {
    const on = (e) => setBurst({ key: Date.now(), line: e.detail?.line || LINES[Math.floor(Math.random() * LINES.length)], custom: !!e.detail?.line });
    window.addEventListener('focus-critter:day-done', on);
    return () => window.removeEventListener('focus-critter:day-done', on);
  }, []);
  useEffect(() => {
    if (!burst) return undefined;
    const t = setTimeout(() => setBurst(null), 5500);
    if (burst.custom) return () => clearTimeout(t);
    const f = setTimeout(() => {
      axios.get(`${API}/calendar/done-streak`, cfg).then((r) => {
        setBurst((cur) => (cur && cur.key === burst.key ? { ...cur, streak: r.data.streak, badge: r.data.new_badge } : cur));
        if (r.data.new_badge) axios.post(`${API}/calendar/done-streak/seen`, { days: r.data.new_badge.days }, cfg).catch(() => {});
      }).catch(() => {});
    }, 1200);
    return () => { clearTimeout(t); clearTimeout(f); };
  }, [burst?.key]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!burst) return null;
  const pieces = Array.from({ length: 60 }, (_, i) => ({
    left: Math.random() * 100, delay: Math.random() * 0.6, dur: 1.8 + Math.random() * 1.4,
    color: COLORS[i % COLORS.length], size: 6 + Math.random() * 8, rot: Math.random() * 360, round: i % 3 === 0,
  }));
  return (
    <div key={burst.key} className="fixed inset-0 z-[400] pointer-events-none overflow-hidden" data-testid="day-done-celebration">
      <style>{'@keyframes ddfall{0%{transform:translateY(-10vh) rotate(0deg);opacity:1}100%{transform:translateY(105vh) rotate(720deg);opacity:.9}}@keyframes ddpop{0%{transform:translate(-50%,20px) scale(.8);opacity:0}15%{transform:translate(-50%,0) scale(1);opacity:1}85%{opacity:1}100%{opacity:0}}'}</style>
      {pieces.map((p, i) => (
        <span key={i} className="absolute top-0 block" style={{
          left: `${p.left}%`, width: p.size, height: p.round ? p.size : p.size * 0.45, background: p.color,
          borderRadius: p.round ? '50%' : 2, transform: `rotate(${p.rot}deg)`,
          animation: `ddfall ${p.dur}s ${p.delay}s cubic-bezier(.25,.6,.4,1) forwards`,
        }} />
      ))}
      <div className="absolute left-1/2 top-24 max-w-md w-[90%] rounded-2xl px-5 py-4 text-center shadow-xl"
        style={{ background: '#F4EEE1', border: '3px double #2B2620', animation: 'ddpop 5.5s ease forwards' }} data-testid="day-done-line">
        <div className="text-3xl mb-1">👵🏼🎉</div>
        <p className="font-bold text-[#2B2620]" style={{ fontFamily: "'Libre Baskerville', Georgia, serif" }}>{burst.line}</p>
        {burst.streak > 0 && <p className="mt-2 text-sm font-black text-[#8A4B10]" data-testid="day-done-streak">🔥 {burst.streak} {burst.streak === 1 ? 'dag' : 'dagar'} i rad!</p>}
        {burst.badge && (
          <div className="mt-2 inline-flex items-center gap-2 rounded-full px-3 py-1 bg-[#FFE8A3] border-2 border-[#F5B841]" data-testid="day-done-badge">
            <span className="text-2xl animate-bounce">{burst.badge.emoji}</span>
            <span className="text-xs font-black text-[#2B2620]">Nytt märke: {burst.badge.name}!</span>
          </div>
        )}
        <p className="text-[10px] uppercase tracking-[0.3em] mt-2 text-[#6B7246] font-black">Farmor Elsa</p>
      </div>
    </div>
  );
}
